import { useOnboarding, guideSteps } from "hooks/useOnboarding";

const info = {
  [guideSteps.PROFILE]: {
    title: "Dashboard Tutorial",
    description:
      "Get to know your dashboard in just a few clicks! Let’s walk you through the essentials.",
  },
  [guideSteps.NEW_BUTTON]: {
    title: "Add a new button",
    description: "Add a new button for your intended Referral Recipient.",
  },
  [guideSteps.BUTTON]: {
    title: "Send your first referral",
    description: "Click the button to instantly trigger a referral to your Referral Recipient.",
  },
  [guideSteps.BUTTON_QUESTION]: {
    title: "Ask a question",
    description: "Click the button and select 'Ask a Question' to contact your Referral Recipients for any inquiries.",
  },
  [guideSteps.WEBSITE]: {
    title: "More About us",
    description:
      "This is our website. You can read more information about us.",
  },
};

export const Onboarding = ({ originator }) => {
  const {
    isOnboardingFinished,
    currentStep,
    nextStep,
    prevStep,
    finishOnboarding,
    onboardingTarget,
    posLeft,
    posTop,
    currentStepIndex,
    stepsLength,
  } = useOnboarding({ originator });

  if (isOnboardingFinished || !onboardingTarget) {
    return null;
  }

  return (
    <>
      <div
        id="onboarding-marker"
        className="absolute bg-white rounded-xl shadow-2xl mr-4 border-solid border-gray-200 border-2 max-w-96 z-50"
        style={{ top: posTop, left: posLeft }}
      >
        <div className="relative pt-4 pb-4 pl-8 pr-8 text-sm">
          <div className="absolute -top-3 -left-3 bg-blue-600 w-6 h-6 rounded-full"></div>
          <div
            onClick={finishOnboarding}
            className="absolute top-2 right-2 hover:bg-gray-100 w-6 h-6 cursor-pointer rounded-full"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div className="font-bold text-lg mb-1">{info[currentStep].title}</div>
          <div>{info[currentStep].description}</div>
          <div className="flex flex-row justify-between items-end">
            <div className="text-md font-semibold text-gray-500">
              {currentStepIndex} of {stepsLength}
            </div>
            <div className="flex flex-row gap-2">
              {currentStep !== Object.keys(guideSteps)[0] && (
                <button
                  onClick={prevStep}
                  className="bg-gray-200 hover:bg-gray-100 text-gray-600 font-bold rounded-lg px-4 py-2 mt-4"
                >
                  Previous step
                </button>
              )}
              <button
                onClick={nextStep}
                className="bg-black hover:bg-gray-800 text-white font-bold rounded-lg px-4 py-2 mt-4"
              >
                {currentStepIndex === stepsLength ? "Finish" : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed top-0 bottom-0 left-0 right-0 bg-black z-30 opacity-20"></div>
    </>
  );
};
